var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colRefForm"},[_c('div',{staticClass:"intro"},[_vm._v("Confirmación de datos")]),_c('div',{staticClass:"txtform"},[_c('p',[_vm._v("Invitamos a todos los estudiantes a validar la información suministrada, con el fin de garantizar el proceso de Verificación de paz y salvos.")])])])
}]

export { render, staticRenderFns }